import React, { useState, useEffect, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'

import GoogleMap from '../GoogleMap/GoogleMap'
import FullSlider from '../Slider/FullSlider'
import setValue from '../../../shared/actions/setValue'
import { hideBodyScroll, showBodyScroll } from 'js/shared/utils'

const getBlockHeight = (selector) => {
  const el = document.querySelector(selector);
  return el?.clientHeight || 0;
};

const FullMap = ({
  isDestination = false,
  isOffers = false,
  zoomButton,
  itemComponent,
  zoomOutButton,
  hidden = true,
}) => {
  const dispatch = useDispatch();

  const { fullMap, results, loading } = useSelector((state) => ({
    fullMap: state.main.fullMap,
    results: state.main.results || [],
    loading: state.globalLoader.isShow,
  }));

  const [selectedSliderItem, setSelectedSliderItem] = useState(null);

  const setOwnValue = useCallback((key, value) => {
    dispatch(setValue(key, value));
  }, [dispatch]);

  useEffect(() => {
    const onKeyUp = (e) => {
      if (e.key === 'Escape' && fullMap) {
        setOwnValue('fullMap', false);
        document.body.style = undefined;
      }
    };

    document.addEventListener('keyup', onKeyUp, false);
    return () => document.removeEventListener('keyup', onKeyUp, false);
  }, [fullMap, setOwnValue]);

  useEffect(() => {
    if (fullMap) {
      hideBodyScroll();
    } else {
      showBodyScroll();
    }

    return () => showBodyScroll();
  }, [fullMap]);

  const activeSlide = useMemo(() => {
    let ke = 1;
    results.forEach((item, key) => {
      if (item.active === true) {
        ke = key + 1;
      }
    });
    return ke;
  }, [results]);

  const changeActiveMarker = useCallback((id) => {
    setSelectedSliderItem(id);
  }, []);

  const calculateTopOffset = () => {
    return getBlockHeight('.site-header') + getBlockHeight('.mobile-search-wrap');
  };

  return (
    <div
      style={{
        display: fullMap ? 'block' : 'none',
        position: 'fixed',
        top: calculateTopOffset(),
        right: 0,
        left: 0,
        bottom: 0,
        zIndex: 5,
        background: 'white',
      }}
    >
      {fullMap && (
        <>
          <GoogleMap
            isDestination={isDestination}
            results={results}
            style={{ height: '100%' }}
            isFullMap
            isOffers={isOffers}
            selectedSliderItem={selectedSliderItem}
            zoomButton={zoomButton}
            zoomOutButton={zoomOutButton}
          />

          {results.length > 0 && itemComponent && (
            <FullSlider
              isDestination={isDestination}
              active={activeSlide}
              results={results}
              loading={loading}
              itemComponent={itemComponent}
              onSelectSliderItem={changeActiveMarker}
            />
          )}
        </>
      )}
    </div>
  )
}

FullMap.propTypes = {
  isDestination: PropTypes.bool,
  isOffers: PropTypes.bool,
  zoomButton: PropTypes.any,
  itemComponent: PropTypes.any,
  zoomOutButton: PropTypes.any,
  hidden: PropTypes.bool,
}

export default React.memo(FullMap);
